import { render, staticRenderFns } from "./3_identity.vue?vue&type=template&id=fe0c78be&scoped=true&"
import script from "./3_identity.vue?vue&type=script&lang=js&"
export * from "./3_identity.vue?vue&type=script&lang=js&"
import style0 from "./3_identity.vue?vue&type=style&index=0&id=fe0c78be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0c78be",
  null
  
)

export default component.exports